import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link"
import AnchorLink from 'react-anchor-link-smooth-scroll'

export default function FeaturedEmployersImageWithText({
    global,
    pathPrefix,
    customClass = "",
    post,
}) {
    return (
        post?.length >= 1 && (
            <section className={`${styles.root} ${customClass}`}>
                <Container>
                    {post?.map((post, index) => (
                        <Row key={index} className={`mainWrapper align-items-center mb-5`} id={`section-${index}`}>
                            <Col md={6}>
                                <SourceFlowImage
                                    src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                    size="1000x"
                                    alt={`${post?.id}`}
                                    className="card-img"
                                />
                            </Col>
                            <Col md={6}>
                                <div className="post-content mb-4">
                                    {post?.content ?
                                        <div id="post-contents" dangerouslySetInnerHTML={{ __html: post?.content }} />
                                        : ""}
                                    {post?.buttonanchorsection ?
                                        <AnchorLink offset='80' href={`#${post?.buttonlink}`} className="primaryBtn no-arrow banner-anchor mt-4" aria-label="Scroll Bottom">
                                            {post?.buttontitle}
                                        </AnchorLink>
                                        :
                                        <>
                                            {post?.buttonlink && post?.buttontitle && (
                                                post?.buttonnewtabpage ?
                                                    <Link href={`${post?.buttonlink}`}>
                                                        <a className="primaryBtn no-arrow mt-4" target="_blank" rel="noreferrer noopener">
                                                            {post?.buttontitle}
                                                        </a>
                                                    </Link> :
                                                    <Link href={`${post?.buttonlink}`}>
                                                        <a className="primaryBtn no-arrow mt-4">
                                                            {post?.buttontitle}
                                                        </a>
                                                    </Link>
                                            )}
                                        </>}
                                </div>
                            </Col>
                        </Row>
                    ))}
                </Container>
            </section>
        )
    )
}